import React from 'react';
import PropTypes from 'prop-types';
import { Form as FormikForm } from 'formik';

const Form = props => <FormikForm {...props}>{props.children}</FormikForm>;

Form.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Form;
